<template lang="pug">
    .fullscreen-dialog
        .text Открыть на весь экран?
        .actions
            button Да
            button Нет
</template>
<script>
export default {
  name: 'FullscreenDialog',
  data() {
    return {}
  }
}
</script>